module.exports = __webpack_public_path__ + "videos/gestures_en.598aa5e.mp4";